import "slick-carousel";
import "lazysizes";
import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import PortalVue from "portal-vue";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";

import "./plugins/dropdown.plugin";
import "./plugins/mobileNavigation.plugin";
import "./plugins/stickyElement.plugin";
import "./plugins/stickyHeader.plugin";
import "./plugins/tabs.plugin";

import BpAccordion from "../styles/molecules/accordion/BpAccordion";
import BpAccordionList from "../styles/organisms/accordionList/BpAccordionList";
import BpCarousel from "../styles/organisms/carousel/BpCarousel";
import BpClickable from "../styles/utilities/clickable/BpClickable";
import BpDirectional from "../styles/utilities/directional/BpDirectional";
import BpDismissable from "../styles/utilities/dismissable/BpDismissable";
import BpDropdown from "../styles/atoms/dropdown/BpDropdown";
import BpMobileNavigation from "../styles/organisms/mobile-navigation/BpMobileNavigation";
import BpModal from "../styles/organisms/modal/BpModal";
import BpTabs from "../styles/molecules/tabs/BpTabs";

import Vue from "vue";

import Filtering from "./filtering.js";

Vue.use(PortalVue);

// eslint-disable-next-line
new Vue({
    el: "#root",
    mixins: [Filtering],
    components: {
        BpAccordion,
        BpAccordionList,
        BpCarousel,
        BpClickable,
        BpDirectional,
        BpDismissable,
        BpDropdown,
        BpMobileNavigation,
        BpModal,
        BpTabs,
        Swiper,
        SwiperSlide,
    },
});

(function runLogoSlider() {

    const logoSlider = document.querySelector('.splide');

    const motionQuery = matchMedia('(prefers-reduced-motion)')

    if(!logoSlider) return;

    const splide = new Splide( '.splide', {
        type   : 'loop',
        drag   : 'free',
        focus  : 'center',
        arrows: false,
        pagination: false,
        slideFocus: false,
        mediaQuery: 'min',
        autoWidth: true,
        speed: 0,
        gap: '55px',
        breakpoints: {
                616: {
                },
                1000: {
                    gap: '93px',
                },
        },
        autoScroll: {
          pauseOnFocus: false,
          pauseOnHover: false,
        },
    } );  

    motionQuery.matches ? splide.mount( { } ) : splide.mount( { AutoScroll } );

})();